import { Box } from "@mui/material";

const HTMLDisplay = ({ html, noStyle }) => {
  return (
    <>
      {noStyle ? (
        <Box dangerouslySetInnerHTML={{ __html: html }} />
      ) : (
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            margin: "0 auto",
            padding: 2,
            border: "1px solid #ccc",
            borderRadius: 2,
            backgroundColor: "#f9f9f9",
            overflowX: "auto",
            "& img": {
              maxWidth: "100%",
              height: "auto",
            },
            "& table": {
              maxWidth: "100%",
              tableLayout: "auto",
            },
          }}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      )}
    </>
  );
};

export default HTMLDisplay;
